import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, filter }) =>
    present(
      repository
        .getPlanzoneResourcesListing(filter)
        .then(({ resources, totalPages }) => ({
          planzone,
          filter,
          resources,
          totalPages,
        }))
        .catch(() => Promise.reject({ planzone, filter })),
    );
}

export type { Interactor };

export { createInteractor };
